import script from "./KColourCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./KColourCode.vue?vue&type=script&setup=true&lang=ts"

import "./KColourCode.vue?vue&type=style&index=0&id=c7f5ff58&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7f5ff58"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
